<div class="closing-x-wrap">
    <mat-icon class="close-icon" alt="Close dialog" (click)="cancel()"> close </mat-icon>
</div>

<section>
    <form [formGroup]="newPasswordForm" (ngSubmit)="newPasswordSubmit()">
        <h1>{{ title }}</h1>
        <mat-form-field *ngIf="!temporaryPassword" appearance="fill">
            <mat-label>Current Password</mat-label>
            <input
                [type]="viewCurrentPassword ? 'text' : 'password'"
                autocomplete="off"
                matInput
                formControlName="currentPassword"
                maxlength="30"
                [host]="this"
                appValidatePassword="currentPassword"
            />
            <mat-icon matSuffix (click)="passwordVisible('viewCurrentPassword')" class="my-icon">{{
                viewCurrentPassword ? 'visibility_off' : 'visibility'
            }}</mat-icon>
            <mat-error *ngIf="newPasswordForm.controls.currentPassword.errors?.required">Invalid password</mat-error>
            <mat-error *ngIf="newPasswordForm.controls.currentPassword.errors?.currentPasswordError">{{ currentPasswordError }}</mat-error>
        </mat-form-field>
        <p>Password requires at least:</p>
        <div class="requirements">
            <div class="icons">
                <ng-container *ngIf="!temporaryPassword">
                    <mat-icon *ngIf="passwordRequirements?.oldPassword; else noOldPW">check</mat-icon>
                    <ng-template #noOldPW>
                        <mat-icon></mat-icon>
                    </ng-template>
                </ng-container>
                <mat-icon *ngIf="passwordRequirements?.hasMinLength; else noMin">check</mat-icon>
                <ng-template #noMin>
                    <mat-icon></mat-icon>
                </ng-template>
                <mat-icon *ngIf="passwordRequirements?.hasLower; else noLower">check</mat-icon>
                <ng-template #noLower>
                    <mat-icon></mat-icon>
                </ng-template>
                <mat-icon *ngIf="passwordRequirements?.hasUpper; else noUpper">check</mat-icon>
                <ng-template #noUpper>
                    <mat-icon></mat-icon>
                </ng-template>
                <mat-icon *ngIf="passwordRequirements?.hasNumber; else noNum">check</mat-icon>
                <ng-template #noNum>
                    <mat-icon></mat-icon>
                </ng-template>
                <mat-icon *ngIf="passwordRequirements?.hasSpecialChar; else noSpecialChar">check</mat-icon>
                <ng-template #noSpecialChar>
                    <mat-icon></mat-icon>
                </ng-template>
                <ng-container *ngIf="!temporaryPassword">
                    <mat-icon *ngIf="passwordRequirements?.bothMatch; else noMatch">check</mat-icon>
                    <ng-template #noMatch>
                        <mat-icon></mat-icon>
                    </ng-template>
                </ng-container>
            </div>
            <ul>
                <li *ngIf="!temporaryPassword" [ngClass]="passwordRequirements?.oldPassword ? 'requirement-met' : 'requirement-not-met'">Current password</li>
                <li [ngClass]="passwordRequirements?.hasMinLength ? 'requirement-met' : 'requirement-not-met'">A minimum of 8 characters</li>
                <li [ngClass]="passwordRequirements?.hasLower ? 'requirement-met' : 'requirement-not-met'">A lowercase letter</li>
                <li [ngClass]="passwordRequirements?.hasUpper ? 'requirement-met' : 'requirement-not-met'">An uppercase letter</li>
                <li [ngClass]="passwordRequirements?.hasNumber ? 'requirement-met' : 'requirement-not-met'">A number</li>
                <li [ngClass]="passwordRequirements?.hasSpecialChar ? 'requirement-met' : 'requirement-not-met'">
                    Any special character (the "_" character is not a special character)
                </li>
                <li *ngIf="!temporaryPassword" [ngClass]="passwordRequirements?.bothMatch ? 'requirement-met' : 'requirement-not-met'">
                    Both passwords must match
                </li>
            </ul>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>{{ passwordInputLabel }}</mat-label>
            <input
                [type]="viewPassword ? 'text' : 'password'"
                autocomplete="off"
                matInput
                formControlName="password"
                maxlength="30"
                [host]="this"
                appValidatePassword="password"
            />
            <mat-icon *ngIf="!temporaryPassword" matSuffix (click)="passwordVisible('viewPassword')" class="my-icon">{{
                viewPassword ? 'visibility_off' : 'visibility'
            }}</mat-icon>
            <mat-error>Invalid password</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="!temporaryPassword" appearance="fill">
            <mat-label>Confirm New Password</mat-label>
            <input
                [type]="viewPassword2 ? 'text' : 'password'"
                autocomplete="off"
                matInput
                formControlName="password2"
                [host]="this"
                appValidatePassword="password2"
            />
            <mat-icon matSuffix (click)="passwordVisible('viewPassword2')" class="my-icon">{{ viewPassword2 ? 'visibility_off' : 'visibility' }}</mat-icon>
            <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.noMatch">Both passwords must match</mat-error>
            <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.required">Invalid password</mat-error>
        </mat-form-field>
        <div class="button-cont">
            <button class="mt-2 secondary" style="color: var(--tenant-header)" mat-button type="button" (click)="cancel()">Cancel</button>
            <button style="margin-left: 1rem" class="mt-2 primary" mat-button type="submit">Submit</button>
        </div>
    </form>
</section>
<ddj-spinner *ngIf="isLoading"></ddj-spinner>
